import React from 'react';
import { Link } from 'gatsby';
import { Grid, Card } from '@printdeal/ui-library';
import ContentfulCardImage from './ContentfulCardImage';

interface BlogPost {
  id: string;
  title?: string;
  path?: string;
  featuredImage?: {
    url: string;
    title: string;
    width: number;
    height: number;
  };
  featuredDescription?: {
    featuredDescription?: string;
  };
}

export interface BlogPostsGridProps {
  posts: BlogPost[];
}

const BlogPostsGrid = ({ posts }: BlogPostsGridProps) => {
  if (posts.length === 0) {
    return null;
  }

  return (
    <Grid className="pd-grid-cols-2 pd-items-stretch pd-gap-4 md:pd-grid-cols-3">
      {posts.map((post, index) => {
        const {
          id,
          title = '',
          path = '',
          featuredImage = Object.create(null),
        } = post;
        return (
          <Card
            as={Grid.Item}
            key={id}
            data-testid="blog-post-card"
            title={title}
            image={featuredImage && (
              <ContentfulCardImage
                src={featuredImage.url}
                alt={featuredImage.title}
                priority={index < 4}
                aspectRatio={3 / 2}
              />
            )}
            link={<Link to={path}>{title}</Link>}
          />
        );
      })}
    </Grid>
  );
};

export default BlogPostsGrid;
